(function() {
    $("#changeMyCounty").find('.daat-modal-closer').on('click', function(){
        $("#changeMyCounty").modal('toggle');
    });
})();